import React from "react";
import { ArticleExpertCard } from "@aph/ui-lib-humanx";
import { useRouter } from "next/navigation";
import Slider, { Slide } from "@/components/Slider";
import routes from "@/helpers/router";
import IconPlus from "$/icons/icon-plus.svg";
import IconRight from "$/icons/icon-right.svg";
import IconLeft from "$/icons/icon-left.svg";
import { ArticleInfo as ArticleInfoInterface } from "@/components/ArticleInfo/interface";
import ButtonLink from "@/components/ButtonLink";
import { CategoryIconType } from "@/components/PageHome/interfaces";
import Bookmark from "@/components/BookmarkAction";
import { NON_ONBOARDED_STATUS, ONBOARDING_STATUS, TYPE_ARTICLE } from "@/helpers/constants";
import { assetClickedEvent } from "@/helpers/TSDEvents";
import { useAppSelector } from "@/redux/hooks";
import SegmentInfoSelector from "@/redux/slice/auth/selectors/userSegmentInfo";
import { getPlainTexts } from "@/helpers";
import styles from "./ArticleInfo.module.scss";

const ArticleInfo = (props) => {
  const { userAgent, articles, ctaURL, desktopItems = 2, sectionTitle = "", assetPosition } = props;

  const router = useRouter();
  const SegmentInfoObject = useAppSelector(SegmentInfoSelector);

  return (
    <>
      {!!articles?.length && (
        <div className={`${styles.articles} ${userAgent.isMobile ? styles.isMobile : ""}`}>
          <Slider
            dotsWrapperClass={styles.dotsWrapperClass}
            dotClass={styles.dotClass}
            slidesToShow={userAgent?.isDesktop ? desktopItems : 1.1}
            dotClassActive={styles.dotClassActive}
            center={!userAgent?.isDesktop}
            columnGap={userAgent?.isDesktop ? 20 : 0}
            autoplay={userAgent?.isDesktop ? Boolean(articles?.length > desktopItems) : Boolean(articles?.length > 1)}
            showArrows={userAgent?.isDesktop}
            nextArrow={<IconRight className={`${styles.arrows} ${styles.arrowNext}`} />}
            prevArrow={<IconLeft className={`${styles.arrows} ${styles.arrowPrev}`} />}
          >
            {articles.map((article: ArticleInfoInterface, index) => {
              const { id, Slug, Title, Description, AuthorName, ReadTime, Image, CategoryName } = article;
              const redirectUrl = routes.article(Slug);

              return (
                <Slide key={id} index={index}>
                  <ArticleExpertCard
                    iconType={CategoryIconType[CategoryName]}
                    className={styles.article}
                    tagText={CategoryName}
                    imageUrl={Image?.data?.attributes?.url}
                    readTimeText={ReadTime}
                    doctorName={AuthorName}
                    doctorIcon={<IconPlus className={styles.iconPlus} width={20} height={20} />}
                    ctaText={"Read more"}
                    ctaClick={() => {
                      assetClickedEvent({
                        asset_name: getPlainTexts(sectionTitle),
                        asset_display_text: Title,
                        asset_position: assetPosition,
                        asset_element_position: index + 1,
                        momverse_stage: SegmentInfoObject?.type
                          ? (ONBOARDING_STATUS[SegmentInfoObject?.type] ?? "")
                          : NON_ONBOARDED_STATUS,
                      });
                      router.push(redirectUrl);
                    }}
                    rawTitle={Title}
                    redirectUrl={redirectUrl}
                    rawSubTitle={Description}
                    isCircleIcon
                    isImageCover
                    bannerImageHeight="160px"
                    bookmark={<Bookmark type={TYPE_ARTICLE} itemId={article?.id} section={sectionTitle} />}
                  />
                </Slide>
              );
            })}
          </Slider>
        </div>
      )}
      {ctaURL && (
        <ButtonLink href={ctaURL} className={"btn"} color="primarybaby">
          View all articles
        </ButtonLink>
      )}
    </>
  );
};

export default ArticleInfo;
